export default "__VITE_ASSET__RCJg94S$__"